import store from "@/state/store";
import CampaignCartItem from "@/helpers/cart/CampaignCartItem";
import InfluencerCartItem from "@/helpers/cart/InfluencerCartItem";
import PricePackageCartItem from "@/helpers/cart/PricePackageCartItem";
import Vue from "vue";

export const state = {
    cart: {},
};

export const getters = {
    getAllItems(state) {
        return state.cart;
    },
    campaignsCount(state) {
        return Object.keys(state.cart).length;
    },
    cartItemsCount(state) {
        let count = 0;
        // eslint-disable-next-line no-unused-vars
        for (let [_, campaignCartItem] of Object.entries(state.cart)) {
            // eslint-disable-next-line no-unused-vars
            for (let [_, influencerCartItem] of Object.entries(campaignCartItem.influencerCartItems)) {
                count += Object.keys(influencerCartItem.pricePackageCartItems).length
            }
        }
        return count;
    }
};

export const mutations = {
    SET_CART(state, cart) {
        state.cart = cart;
    },
    ADD(state, cartItem) {
        const campaignId = cartItem.campaign._id
        const influencerId = cartItem.influencer._id
        const pricePackageId = cartItem.pricePackage._id

        let campaignCartItem = null;
        if (state.cart.hasOwnProperty(campaignId)) {
            campaignCartItem = state.cart[campaignId];
        } else {
            campaignCartItem = new CampaignCartItem(cartItem.campaign._id, cartItem.campaign.internal_name)
        }

        if (!campaignCartItem.containsInfluencerCartItem(influencerId)) {
            campaignCartItem.putInfluencerCartItem(
                new InfluencerCartItem(influencerId, cartItem.influencer.username ?? cartItem.influencer.name, cartItem.influencer.profile_picture_url, cartItem.influencer.social_network_accounts)
            )
        }
        // if campaignCartItem already contains an influencer, update its state with new data for profile picture and social networks
        const influencerCartItem = campaignCartItem.getInfluencerCartItem(influencerId);
        influencerCartItem.profilePictureUrl = cartItem.influencer.profile_picture_url;
        influencerCartItem.socialNetworkAccounts = cartItem.influencer.social_network_accounts;

        if (!influencerCartItem.containsPricePackageCartItem(pricePackageId)) {
            influencerCartItem.putPricePackageCartItem(
                new PricePackageCartItem(cartItem.pricePackage, 0)
            )
        }
        const pricePackageCartItem = influencerCartItem.getPricePackageCartItem(pricePackageId);
        pricePackageCartItem.incrementAmount(cartItem.amount)

        Vue.set(state.cart, campaignId, campaignCartItem)

        store.dispatch('cart/saveInStorage').then();
    },
    CHANGE_PRICE_PACKAGE_AMOUNT(state, {campaignId, influencerId, pricePackageId, newAmount}) {
        state.cart[campaignId].influencerCartItems[influencerId].pricePackageCartItems[pricePackageId].amount = newAmount;
        store.dispatch('cart/saveInStorage').then();
    },
    REMOVE_PRICE_PACKAGE(state, {campaignId, influencerId, pricePackageId}) {
        Vue.delete(state.cart[campaignId].influencerCartItems[influencerId].pricePackageCartItems, pricePackageId)

        if (Object.keys(state.cart[campaignId].influencerCartItems[influencerId].pricePackageCartItems).length === 0) {
            Vue.delete(state.cart[campaignId].influencerCartItems, influencerId)
        }

        if (Object.keys(state.cart[campaignId].influencerCartItems).length === 0) {
            Vue.delete(state.cart, campaignId);
        }

        store.dispatch('cart/saveInStorage').then();
    },
    REMOVE_CAMPAIGN_CART_ITEM(state, campaignId) {
        Vue.delete(state.cart, campaignId);
        store.dispatch('cart/saveInStorage').then();
    },
    CLEAR_CART(state) {
        state.cart = {};
        store.dispatch('cart/saveInStorage').then();
    },
};

export const actions = {
    loadFromStorage({ commit, rootGetters }) {
        // Deserialize into CartItem classes
        let currentCart = JSON.parse(localStorage.getItem(`cart_${rootGetters['user/userId']}`));
        if (currentCart == null) {
            return
        }
        for (let campaignId in currentCart) {
            const campaignCartItem = Object.assign(new CampaignCartItem, currentCart[campaignId])
            currentCart[campaignId] = campaignCartItem;
            for (let influencerId in campaignCartItem.influencerCartItems) {
                campaignCartItem.influencerCartItems[influencerId] = Object.assign(new InfluencerCartItem, campaignCartItem.influencerCartItems[influencerId])
                for (let pricePackageId in campaignCartItem.influencerCartItems[influencerId].pricePackageCartItems) {
                    campaignCartItem.influencerCartItems[influencerId].pricePackageCartItems[pricePackageId]
                        = Object.assign(new PricePackageCartItem, campaignCartItem.influencerCartItems[influencerId].pricePackageCartItems[pricePackageId])
                }
            }
        }

        commit('SET_CART', currentCart);
    },
    saveInStorage({ getters, rootGetters }) {
        localStorage.setItem(`cart_${rootGetters['user/userId']}`, JSON.stringify(getters['getAllItems']))
    }
};
